import React, { useState } from "react";
import styles from "./style.module.css";
import Typography from "../../components/Typography/Typography";
import { HeroGallery } from "../../assets/webp";
import { NewsLetterChevron } from "../../assets/svgs";
import { openXfacebook, openXinstagram, openXlinkedin, openXtwitter, openXyoutube } from "../../assets/socials";
import AnimatedButton from "../../components/AnimatedButton";

export const NewsletterSection: React.FC = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription logic here
    console.log("Subscribing email:", email);
    setEmail("");
  };

  return (
    <div className={styles.newsletterContainer}>
      <section className={styles.newsletterSection}>
        {/* <div className={styles.content}> */}
          <div className={styles.headerSection}>
            <Typography
              variant="heading2"
              fontFamily="satoshi"
              weight="bold"
              className={styles.title}
            >
              Stay In The Loop Be The First To Key Into Information
            </Typography>
          </div>

          <div className={styles.subtitleSection}>
            <Typography
              variant="bodyRegular"
              fontFamily="satoshi"
              weight="regular"
              className={styles.subtitle}
            >
              Join our newsletter and be the first to know about exclusive updates, fresh content, and special offers straight to your inbox. No spam. Just value.
            </Typography>
          </div>

          <form onSubmit={handleSubscribe} className={styles.subscriptionForm}>
            <div className={styles.inputContainer}>
              <input
                type="email"
                placeholder="Subscribe"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={styles.emailInput}
                required
              />
              <AnimatedButton 
              variant="primary"
              type="submit" 
              className={styles.subscribeButton}>
                <img
                src={NewsLetterChevron}
                alt="Newsletter submit chevron"
                  width="16.970001914676164"
                  height="20"
                  className={styles.arrowIcon}
                />
              </AnimatedButton>
            </div>
          </form>

          <div className={styles.socialSection}>
            <img
              src={HeroGallery}
              alt="Social media showcase"
              className={styles.socialImage}
            />
            
            <div className={styles.socialOverlay}>
              <Typography
                variant="bodySmall"
                fontFamily="satoshi"
                weight="regular"
                size="base"
                className={styles.socialText}
              >
                Checkout our social for more exclusive content
              </Typography>
              
          <div className={styles.socialLinks}>
            <a href="hello#" className={styles.socialLink} aria-label="Twitter">
              <img src={openXtwitter} alt="Twitter" width="20" height="20" />
            </a>
            <a href="hello#" className={styles.socialLink} aria-label="YouTube">
              <img src={openXyoutube} alt="YouTube" width="20" height="20" />
            </a>
            <a href="hello#" className={styles.socialLink} aria-label="Instagram">
              <img src={openXinstagram} alt="Instagram" width="20" height="20" />
            </a>
            <a href="hello#" className={styles.socialLink} aria-label="LinkedIn">
              <img src={openXlinkedin} alt="LinkedIn" width="20" height="20" />
            </a>
            <a href="hello#" className={styles.socialLink} aria-label="Facebook">
              <img src={openXfacebook} alt="Facebook" width="20" height="20" />
            </a>
          </div>
            </div>
          </div>
        {/* </div> */}
      </section>
    </div>
  );
};